// ---------------------------------------------------------------------------
// Canonical compound-key builders for the vendor-preferences slice.
//
// These are the SINGLE source of truth for how the normalized maps are keyed.
// Both the extra-reducers (writes) and the selectors (reads) import them, so a
// read and its corresponding write can never drift apart — a silent miss if
// the two were defined independently in each file.
// ---------------------------------------------------------------------------

// Sub-category nodes are keyed by the compound `${categoryUuid}:${subUuid}` so a
// sub uuid that repeats across categories can't collide.
export const subKey = (categoryUuid: string, subUuid: string) => `${categoryUuid}:${subUuid}`;

// Eligible vendors (and the per-key eligible-loading flag) are keyed per slot.
// `subUuid` absent → the category-default slot, keyed with the `default` sentinel.
export const eligibleKey = (categoryUuid: string, subUuid?: string | null) =>
  `${categoryUuid}:${subUuid ?? 'default'}`;
